/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_TitleInputs */



/**
* | output |
* | --- |
* | "Sound settings" |
*
* @param {Practice_Session_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_title = /** @type {((inputs?: Practice_Session_Audio_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geluidsinstellingen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réglages audio")
	return /** @type {LocalizedString} */ ("Sound settings")
});